import {translate, Text, localeFont} from '../utils';
import common from '../common';
import Button from "./Button";

export default class ConfirmDialog extends PIXI.Container {
    constructor(text) {
        super();

        this._tweens = new P3.utils.TWEEN.Group();

        this._approveButton = null;
        this._cancelButton = null;
        this._text = text;
        this.signals = {
            confirm: new P3.utils.MiniSignal(),
            deny: new P3.utils.MiniSignal()
        };

        this.init();
    }

    init() {

        /*
        const bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        bg.tint = 0x0;
        bg.width = common.STAGE_WIDTH;
        bg.height = common.STAGE_HEIGHT * 2;// ?
        bg.anchor.set(0.5);
        bg.alpha = 0.5;
        bg.interactive = true;
        this.addChild(bg);

        this.bg = bg;

         */

        let warningbg = new PIXI.Sprite(P3.assets.texture('undo_warning'));
        warningbg.anchor.set(0.5);
        warningbg.scale.set(1.1);
        warningbg.x = -15;
        warningbg.rotation = -Math.PI * 0.03;
        //  warningbg.scale.set(1.5);
        this.addChild(warningbg);

        let label = new PIXI.Text(this._text, {
            fontFamily: "Fred Fredburger",
            fontSize: 26,
            //  fontFamily: localeFont(),
            align: 'center',
            fill: 0x000000,
            wordWrap: true,
            wordWrapWidth: 450
        });

        //  label.maxWidth = 420;
        label.anchor.set(0.5);
        label.position.x = 55;
        label.position.y = -8;
        label.rotation = -Math.PI * 0.03;
        this.addChild(label);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_ter_yes_out');

        this._approveButton = new Button(states);
        this._approveButton.clickSoundName = "sfx_click";
        this._approveButton.overSoundName = "sfx_rollover";
        this._approveButton.signals.click.add(() => {
            this.signals.confirm.dispatch();
        }, this);
        this._approveButton.position.set(180, 95);
        this.addChild(this._approveButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_ter_no_red_out');

        this._cancelButton = new Button(states);
        this._cancelButton.clickSoundName = "sfx_click";
        this._cancelButton.overSoundName = "sfx_rollover";
        this._cancelButton.signals.click.add(() => {
            this.signals.deny.dispatch();
        }, this);
        this._cancelButton.position.set(0, 110);
        this.addChild(this._cancelButton);

        /*

        this._exclamationPanel = new PIXI.Sprite(P3.assets.texture('panel_caution_exclamation'));
        this._exclamationPanel.anchor.set(0.5);
        this._exclamationPanel.position.set(-250, 20);
        this.addChild(this._exclamationPanel);

        this._exclamationMark = new PIXI.Sprite(P3.assets.texture('icon_exclamation_mark'));
        this._exclamationMark.anchor.set(0.5);
        this._exclamationPanel.addChild(this._exclamationMark);

        this._exclamationMark.rotation = Math.PI * 0.02;
        new P3.utils.TWEEN.Tween(this._exclamationMark, this._tweens)
            .to({rotation: -Math.PI * 0.05}, 940
            ).yoyo(true)
            .repeat(Infinity)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();

         */

    }

    destroy() {
        super.destroy();
    }

    update() {
        this._tweens.update();
    }
}
